import {ILeadModalLeadType} from "../../lead/types/ILeadModalLeadType";
import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../property/types/IPropertyDetailApplication";
import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {getViewTypeName, ViewType} from "../../view_type/ViewType";
import {IGtmProduct} from "../types/IGtmProduct";
import {calculateGtmDimensions, IGtmOffer, IGtmProperty, IGtmRegion, IGtmVendor} from "./calculate_gtm_dimensions";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface IGtmCheckout {
    event: "checkout";
    event_category: "conversation_form" | "standard";
    ecommerce: {
        checkout: {
            actionField: {step: 1};
            products: [IGtmProduct];
        };
    };
}

interface IGtmCheckoutAddData {
    vendor: {
        detail?: IVendorDetailApplication;
    } | null;
    offer: {
        detail?: IOfferDetailApplication;
    } | null;
    property: {
        detail?: IPropertyDetailApplication;
    } | null;
}

export function gtmCheckout(data: IGtmCheckoutAddData, viewType: ViewType | null, leadType: ILeadModalLeadType) {
    const vendorData = (data.vendor && data.vendor.detail) || undefined;
    const offerData = (data.offer && data.offer.detail) || undefined;
    const finalOfferData = offerData ? {...offerData, region: offerData.region.id} : offerData;
    const regionData = (offerData && offerData.region) || undefined;
    const propertyData = (data.property && data.property.detail) || undefined;

    if (vendorData == null) {
        return console.error("interactionHitBasedOnData: require vendor data");
    }

    return hitGtmCheckout(viewType, leadType, vendorData, regionData, finalOfferData, propertyData);
}

const hitGtmCheckout = (
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    vendor: IGtmVendor,
    region?: IGtmRegion,
    offer?: IGtmOffer,
    property?: IGtmProperty
) => {
    // calculate product
    const product: IGtmProduct = {
        ...calculateGtmDimensions(region, offer, property),
        name: (property && property.number) || "na",
        id: property ? property.id.toString() : "na",
        home_listing_id: offer ? (property ? `${offer.id}-${property.id}` : `${offer.id}-0`) : "na",
        group_id: offer ? `${offer.id}-0` : "na",
        price: "1.00",
        brand: vendor ? `${vendor.id}/${vendor.name}` : "na",
        category: offer ? `${offer.id}/${offer.name}` : "na",
        variant: viewType != null ? getViewTypeName(viewType) : "na",
        quantity: 1
    };
    // prepare gtm data and hit
    const gtmData: IGtmCheckout = {
        event: "checkout",
        event_category: leadType === "conversation" ? "conversation_form" : "standard",
        ecommerce: {
            checkout: {
                actionField: {step: 1},
                products: [product]
            }
        }
    };
    hitGoogleTagManager(gtmData);
    return true;
};
import {ILeadModalLeadType} from "../../lead/types/ILeadModalLeadType";
import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../property/types/IPropertyDetailApplication";
import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {getViewTypeName, ViewType} from "../../view_type/ViewType";
import {IGtmProduct} from "../types/IGtmProduct";
import {calculateGtmDimensions, IGtmOffer, IGtmProperty, IGtmRegion, IGtmVendor} from "./calculate_gtm_dimensions";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

interface IGtmCheckout {
    event: "checkout";
    event_category: "conversation_form" | "standard";
    ecommerce: {
        checkout: {
            actionField: {step: 1};
            products: [IGtmProduct];
        };
    };
}

interface IGtmCheckoutAddData {
    vendor: {
        detail?: IVendorDetailApplication;
    } | null;
    offer: {
        detail?: IOfferDetailApplication;
    } | null;
    property: {
        detail?: IPropertyDetailApplication;
    } | null;
}

export function gtmCheckout(data: IGtmCheckoutAddData, viewType: ViewType | null, leadType: ILeadModalLeadType) {
    const vendorData = (data.vendor && data.vendor.detail) || undefined;
    const offerData = (data.offer && data.offer.detail) || undefined;
    const finalOfferData = offerData ? {...offerData, region: offerData.region.id} : offerData;
    const regionData = (offerData && offerData.region) || undefined;
    const propertyData = (data.property && data.property.detail) || undefined;

    if (vendorData == null) {
        return console.error("interactionHitBasedOnData: require vendor data");
    }

    return hitGtmCheckout(viewType, leadType, vendorData, regionData, finalOfferData, propertyData);
}

const hitGtmCheckout = (
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    vendor: IGtmVendor,
    region?: IGtmRegion,
    offer?: IGtmOffer,
    property?: IGtmProperty
) => {
    // calculate product
    const product: IGtmProduct = {
        ...calculateGtmDimensions(region, offer, property),
        name: (property && property.number) || "na",
        id: property ? property.id.toString() : "na",
        home_listing_id: offer ? (property ? `${offer.id}-${property.id}` : `${offer.id}-0`) : "na",
        group_id: offer ? `${offer.id}-0` : "na",
        price: "1.00",
        brand: vendor ? `${vendor.id}/${vendor.name}` : "na",
        category: offer ? `${offer.id}/${offer.name}` : "na",
        variant: viewType != null ? getViewTypeName(viewType) : "na",
        quantity: 1
    };
    // prepare gtm data and hit
    const gtmData: IGtmCheckout = {
        event: "checkout",
        event_category: leadType === "conversation" ? "conversation_form" : "standard",
        ecommerce: {
            checkout: {
                actionField: {step: 1},
                products: [product]
            }
        }
    };
    hitGoogleTagManager(gtmData);
    return true;
};
